/**
 * http配置
 */
import axios from 'axios'
import router from '../router'
import qs from 'querystring'
// axios 配置
axios.defaults.timeout = 1000000;
axios.defaults.withCredentials=true;  //请求带上cookie
// axios.defaults.baseURL = 'http://api.yue360.cn'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// http request 拦截器
axios.interceptors.request.use(
  config => {
    if (config.method === 'post') {
      config.data = qs.stringify(config.data)
    }
    // if (store.state.token) {
    //   config.headers.Authorization = `TBox token ${store.state.token}`
    // }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// http response 拦截器
axios.interceptors.response.use(
  response => {
    // token 已过期，重定向到登录页面
  /*  if (response.data.code === 1001) {
      router.replace({
        path: '/login',
        query: {redirect: router.currentRoute.fullPath}
      })
    }    if (response.data.code === 1001) {
      router.replace({
        path: '/login',
        query: {redirect: router.currentRoute.fullPath}
      })
    }*/
    return response.data
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 401 清除token信息并跳转到登录页面
          router.replace({
            path: '/login',
            query: {redirect: router.currentRoute.fullPath}
          })
      }
    }
    console.log(error)
    // console.log(JSON.stringify(error));//console : Error: Request failed with status code 402
    return Promise.reject(error.response.data)
  }
)

export default axios



// WEBPACK FOOTER //
// ./src/router/http.js